"use client";
import React from "react";
import type { CartLine, Payment } from "@/lib/types/cart-types";

export type CartContextState = {
  lines: CartLine[];
  addLine: (l: CartLine) => void;
  removeLine: (productId: string) => void;
  clear: () => void;
  payments: Payment[];
  addPayment: (p: Payment) => void;
};

const CartContext = React.createContext<CartContextState | null>(null);

export function useCartContext() {
  const ctx = React.useContext(CartContext);
  if (!ctx) throw new Error("useCartContext must be used within CartProvider");
  return ctx;
}
export default CartContext;
